import { fetch } from './http.util';
import { familyApiFetch } from './AuthProvider';
import { config } from './Config';

export async function getUkeplan(kidName) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/${kidName}/storages/ukeplan`, {});
}

export async function uploadUkeplan(kidName, ukeplanUrl) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/${kidName}/storages/ukeplan`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ "ukeplanUrl": ukeplanUrl}),
  });
}

export async function getCalendarEvents(start, end) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/calendars/events`, {});
}

export async function getKidAccountBalance(kidName) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/${kidName}/balance`, {});
}


export async function transferMoney(recipient, amount, base64FaceAuthenticationImage) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/${recipient}/transfermoney`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ "amount": amount, "base64FaceAuthenticationImage": base64FaceAuthenticationImage }),
  });
}

export async function PayWeeklyAllowance(base64FaceAuthenticationImage) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/PayWeeklyAllowance`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ "base64FaceAuthenticationImage": base64FaceAuthenticationImage }),
  });
}

export async function getTodos(familyMemberName, weekRelativeToThisWeek) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/${familyMemberName}/todos?weekRelativeToThisWeek=${weekRelativeToThisWeek}`, {});
}

export async function updateTodo(todo) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/${todo.responsible}/todos/${todo.id}`, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(todo),
  });
}

export async function createTodos() {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/todos`, {
    method: 'POST'
  });
}

export async function getPushUpsStats(familyMemberName) {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}familymembers/${familyMemberName}/push-ups`, {});
}